// Env: .env (production), .env.development (npm start). CRA chỉ expose biến REACT_APP_*
const getEnv = (key: string, fallback: string): string =>
    (process.env[key] ?? fallback).trim();

export const config = {
    HASH: "ebe587e6c53fa4ed7db0a70fc825d406cc522a1b",
    API_URL: getEnv('REACT_APP_API_URL', 'http://localhost:8000/api'),
    APP_NAME: getEnv('REACT_APP_APP_NAME', ''),
    STATUS_CODE: {
        OK: 200,
        BAD_REQUEST: 400,
        FORBIDDEN: 403,
        SERVER_ERROR: 500,
    },
    LOCAL_STORE: {
        ACCOUNT: 'account',
        ACCOUNT_SWITCH: 'aw',
        ACCESS_TOKEN: 'access_token',
        ROLE: 'r',
    },
    TOAST_TYPE: {
        INFO: 'info',
        SUCCESS: 'success',
        ERROR: 'error',
        WARNING: 'warning',
    },
    INTEGRATION: {
        ECONOMIC: {
            REDIRECT_URL: getEnv('REACT_APP_ECONOMIC_REDIRECT_URL', 'https://shipping.2app.dk/economic'),
            PUBLIC_TOKEN: getEnv('REACT_APP_ECONOMIC_PUBLIC_TOKEN', 'xEWLdWWSPz44evs2ENyBJnuO24k8XAXZ1LHnBd78Ww41'),
            REDIRECT_URL_SETUP: getEnv('REACT_APP_ECONOMIC_REDIRECT_URL_SETUP', 'https://shipping.2app.dk/setup'),
        },
    },
};
